import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IbDisruptedSeatsService } from '../services/ib-disrupted-seats.service';
import { IbDisruptedSeatsRefundModel } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-refund-model';
import { IbDisruptedSeatsRefundModalComponent } from '../ib-disrupted-seats-refund-modal/ib-disrupted-seats-refund-modal.component';
import { IbCModalService } from 'ib-web-commons/ib-modal';

@Component({
    selector: 'ib-disrupted-seat-option-three',
    templateUrl: './ib-disrupted-seat-option-three.component.html',
    styleUrls: []
})
export class IbDisruptedSeatOptionThreeComponent {

    @Input() flowId: string;
    @Input() creationDate: string;

    constructor (
        private modalService: NgbModal,
        private disruptedSeatsService: IbDisruptedSeatsService,
        private commonsModalService: IbCModalService
    ) {}

    openRefundModal (): void {
        this.disruptedSeatsService.getDisruptedSeatsRefundInfo(this.flowId, this.creationDate).subscribe({
            next: (response: IbDisruptedSeatsRefundModel) => {
                const modalRef = this.modalService.open(
                    IbDisruptedSeatsRefundModalComponent,
                    {
                        windowClass: 'ib-modals-full fade'
                    }
                );
                modalRef.componentInstance.model = response;
            },
            error: () => {
                this.showGenericError();
            }
        });
    }

    private showGenericError (): void {
        const modalErrorObject = {
            title: 'MODAL_ERROR_TITLE_1',
            body: 'MODAL_ERROR_DESCRIPTION',
            showCancelButton: true
        };
        this.commonsModalService.showGenericError(null, modalErrorObject);
    }
}
